import Vue from "vue";
import { Grid, GridItem } from 'vant';
import { Image as VanImage } from 'vant';
import {
  Button,
  Field,
  Cell,
  CellGroup,
  Icon,
  Row,
  Col,
  Toast,
  Popup,
  Picker,
  Search,
  PullRefresh,
  List,
  Collapse,
  CollapseItem,
  Loading,
  Swipe,
  SwipeItem,
  Tab,
  Tabs,
  Dialog,
  Switch
} from "vant";

Vue.use(Button);
Vue.use(Field);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Icon);
Vue.use(Row).use(Col);
Vue.use(Toast);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(VanImage);
Vue.use(Search);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Loading);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Dialog);
Vue.use(Switch);



Vue.prototype.$toast = Toast;
